// extracted by mini-css-extract-plugin
export default {"header":"UserMenu_header__GzvAC","icon":"UserMenu_icon__AkOKY"};